// Phase 3A compatibility batch, item 3: renders the exact currently
// published Phase 2H booking-terms version (terms/service.py) that a
// public/hosted booking form's acceptance checkbox refers to. Shared by
// PublicBusiness.jsx and BookingIntegrationShell.jsx so the two surfaces
// can't drift into showing terms two different ways.
const SECTION_LABELS = [
  ["deposit_policy", "Deposit"],
  ["cancellation_policy", "Cancellation"],
  ["late_return_policy", "Late Return"],
  ["fuel_policy", "Fuel"],
  ["damage_policy", "Damage"],
  ["travel_restrictions", "Travel Restrictions"],
  ["driver_service_policy", "Driver Service"],
  ["other_terms", "Other Terms"],
];

export default function BookingTermsPanel({ terms, className = "" }) {
  if (!terms) return null;
  const sections = terms.sections || {};
  const entries = SECTION_LABELS
    .map(([key, label]) => [label, sections[key]])
    .filter(([, text]) => text && text.trim());
  if (!entries.length) return null;

  return (
    <div
      data-testid="booking-terms-panel"
      className={`rounded-lg border border-slate-200 bg-slate-50 p-3 text-xs text-slate-700 max-h-64 overflow-y-auto ${className}`}
    >
      <div className="text-[11px] font-semibold uppercase tracking-wide text-slate-500 mb-1.5">
        Booking Agreement: Version {terms.version_number}
      </div>
      {entries.map(([label, text]) => (
        <div key={label} className="mt-2 first:mt-0">
          <strong>{label}:</strong>
          <p className="whitespace-pre-line mt-0.5">{text}</p>
        </div>
      ))}
    </div>
  );
}
